var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-birthdate-particles"},[_c('svg',{ref:"svgElement",attrs:{"viewBox":"-10 -10 400 1024"}},[_c('path',{staticClass:"fuse",attrs:{"d":"M276.2-20.5c22.5,43.5,100.4,162.9,18.5,261.3S97.8,521,160.3,676.9 S-135,763.8-135,763.8","transform":"translate(0 0)","fill":"none","stroke":"#231f20"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }